export default {
  PP_PINK: '#cd6795',
  PP_PROGRESS_BAR_GRAY: '#F4F1F24',
  PP_BLUE: '#395578',
  PP_CHART_TOOLTIP_BG: '#24364D',
  PP_CHART_GREEN: (opacity = 1) => `rgba(98, 177, 111, ${opacity})`,
  PP_CHART_YELLOW: (opacity = 1) => `rgba(224, 182, 76, ${opacity})`,
  PP_CHART_PINK: (opacity = 1) => `rgba(205, 103, 149, ${opacity})`,
  PP_PIE_CHART_TEXT_COLOR: '#24364D',
  PP_BASIC_WHITE: '#FFFFFF',
  PP_BASIC_BLACK: '#000000'
};
